// K+
// import Constants from "../../api/Constants";

export default{
    name: "SectionBanner",
    data(){
        return{

        }
    },
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        },
        imageBackgroundPath: {
            type: String
        }
    }
}
